import { Image, ImagePosition, Link } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import { MarkupText } from "./MarkupText";
export function ParagraphTwoColumnsImageTextWithBackground(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(props.wrapperClassName, "paragraph-container")
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx(props.className, "max-[1070px]:py-0 max-[1070px]:items-start max-[1070px]:flex-col max-[1070px]:justify-center flex w-full h-full py-10 relative")
    }, !!props.imageSource && /*#__PURE__*/ React.createElement(Image, {
        className: "max-[1070px]:hidden absolute top-0 left-0 w-full h-full object-cover -z-10 ",
        source: props.imageSource,
        alt: props.imageAlt || ""
    }), /*#__PURE__*/ React.createElement("div", {
        className: "max-[1070px]:hidden absolute top-0 left-0 w-full h-full backdrop-blur-md bg-black/5 -z-10"
    }), /*#__PURE__*/ React.createElement(InfoWithImage, props)));
}
var InfoWithImage = function(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "h-full w-full max-[1070px]:px-0 container-page flex items-center justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-[1070px]:max-w-full max-[1070px]:mx-0 max-[1070px]:w-full container-content 2xl:max-w-6xl"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("flex flex-col min-[1070px]:flex-row prose min-[1070px]:items-stretch max-[1070px]:w-full max-[1070px]:h-full", {
            "min-[1070px]:flex-row-reverse": props.imagePosition === ImagePosition.Right
        })
    }, !!props.croppedImage && /*#__PURE__*/ React.createElement(Image, {
        className: clsx("hidden min-[1070px]:block object-cover", {
            "min-[1070px]:rounded-e-[0.3125rem]": props.imagePosition === ImagePosition.Right
        }, {
            "min-[1070px]:rounded-s-[0.3125rem]": props.imagePosition === ImagePosition.Left
        }),
        source: props.croppedImage,
        alt: props.imageAlt || ""
    }), !!props.imageSource && /*#__PURE__*/ React.createElement("div", {
        className: "h-full w-full block min-[1070px]:hidden"
    }, /*#__PURE__*/ React.createElement(Image, {
        className: "object-cover h-full w-full block min-[1070px]:hidden",
        source: props.imageSource,
        alt: props.imageAlt || ""
    })), /*#__PURE__*/ React.createElement("div", {
        className: clsx("px-[1.25rem] py-8 min-[1070px]:px-10 min-[1070px]:py-12 w-full bg-white text-gray-700", {
            "min-[1070px]:rounded-s-[0.3125rem]": props.imagePosition === ImagePosition.Right
        }, {
            "min-[1070px]:rounded-e-[0.3125rem]": props.imagePosition === ImagePosition.Left
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-[1070px]:items-start max-[1070px]:max-w-full container-text flex flex-col gap-4 min-[1070px]:gap-5"
    }, !!props.title && /*#__PURE__*/ React.createElement("h2", {
        className: "m-0 text-black"
    }, props.title), /*#__PURE__*/ React.createElement("div", null, !!props.text && /*#__PURE__*/ React.createElement(MarkupText, {
        markup: props.text
    })), !!props.cta && /*#__PURE__*/ React.createElement("div", {
        className: "not-prose"
    }, /*#__PURE__*/ React.createElement(Link, {
        className: "button-primary font-semibold text-sm leading-xs focus-dark",
        href: props.cta.url || "/",
        title: props.cta.title || "/"
    }, props.cta.title)))))));
};
